import React from "react";
import './Article.css'

function ArticleHeader(){
     return(
           <div className="articles">
                     <h5 className="h">Latest articles</h5>
                     <p className="latest">Letest news and trend in the health sector</p>
    
          </div>
          
     )
}
export default ArticleHeader;